import i18nReducer, {
  I18N_REDUCER_KEY,
  selectTranslations,
} from './i18nReducer';
import { loadTranslations } from './i18nReducer';

export { I18N_REDUCER_KEY, selectTranslations, loadTranslations };

export default i18nReducer;
